import React from "react";

// import { Container } from './styles'
import { ReactComponent as ArrowDownSvg } from "../../assets/svgs/arrow-down.svg";
import { ReactComponent as LinkedInSvg } from "../../assets/svgs/LinkedIn.svg";
import { ReactComponent as SuitGuySvg } from "../../assets/svgs/suit-guy.svg";
import { ReactComponent as ArrowRightSvg } from "../../assets/svgs/arrow-right.svg";
import { ReactComponent as BuildingSvg } from "../../assets/svgs/building.svg";
import { ReactComponent as ArrowLeftSvg } from "../../assets/svgs/leftArrow.svg";
import { ReactComponent as CheckboxCircle } from "../../assets/svgs/checkbox-circle.svg";
import { ReactComponent as CloseCircle } from "../../assets/svgs/close-circle.svg";
import { ReactComponent as MenuSvg } from "../../assets/svgs/menu.svg";
import { ReactComponent as ProfilePicture } from "../../assets/svgs/user-profile-photo.svg";
import { ReactComponent as NfSvg } from "../../assets/svgs/nf-menu-icon.svg";
import { ReactComponent as InvoiceSvg } from "../../assets/svgs/invoice-menu-icon.svg";
import { ReactComponent as DocumentsSvg } from "../../assets/svgs/documents-list-menu-icon.svg";
import { ReactComponent as UserSvg } from "../../assets/svgs/user.svg";
import { ReactComponent as UsersSvg } from "../../assets/svgs/users.svg";

type IProps = any & {
  name: string;
};

const Icon: React.FC<IProps> = ({ name, ...rest }) => {
  switch (name) {
    case "arrow-down":
      return <ArrowDownSvg {...rest} />;
    case "linkedin":
      return <LinkedInSvg {...rest} />;
    case "suit-guy":
      return <SuitGuySvg {...rest} />;
    case "arrow-right":
      return <ArrowRightSvg {...rest} />;
    case "building":
      return <BuildingSvg {...rest} />;
    case "arrow-left":
      return <ArrowLeftSvg {...rest} />;
    case "checkbox-circle":
      return <CheckboxCircle {...rest} />;
    case "close-circle":
      return <CloseCircle {...rest} />;
    case "menu":
      return <MenuSvg {...rest} />;
    case "profile-picture":
      return <ProfilePicture {...rest} />;
    case "nf":
      return <NfSvg {...rest} />;
    case "invoice":
      return <InvoiceSvg {...rest} />;
    case "documents":
      return <DocumentsSvg {...rest} />;
    case "user":
      return <UserSvg {...rest} />;
    case "users":
      return <UsersSvg {...rest} />;
    default:
      return null;
  }
};

export default Icon;
